import React, { useState, useEffect } from 'react';

const ItemDetailsBlockVariations = ({ variation_group_title, variation_id = [], onVariationSelect }) => {
    const [selectedVariation, setSelectedVariation] = useState(null);

    useEffect(() => {
        // Notify parent if there's a selected variation
        if (selectedVariation) {
            onVariationSelect(selectedVariation);
        }
    }, [selectedVariation]);

    const handleSelect = (variation) => {
        if (selectedVariation?.id === variation.id) {
            // Do not allow deselecting the only selection
            return;
        }
        setSelectedVariation(variation);
    };

    const isSelected = (variation) => {
        return selectedVariation?.id === variation.id;
    };

    if (variation_id.length == 0) {
        return;
    }

    return (
        <div className="item_details_block_variations">
            <div className="item_details_block_variations_title bold">{variation_group_title}</div>

            <div className="item_details_block_variations_list">
                {variation_id.map((variation) => (

                    <div
                        key={variation.id}
                        className={`item_details_block_variations_item flex ${isSelected(variation) ? 'item_details_block_variations_item_selected' : ''}`}
                        onClick={() => handleSelect(variation)}

                    >
                        <input
                            className="item_details_block_variations_item_indicator"
                            type="radio"
                            name="variations"
                            value={variation.name}
                            checked={isSelected(variation)}
                            onChange={() => handleSelect(variation)}
                        />
                        <div className={`item_details_block_variations_item_name flex_1 bold ${isSelected(variation) ? 'item_details_block_variations_item_name_selected' : ''}`}>
                            {variation.name}
                        </div>

                        {Number(variation.price) > 0 && (
                            <div className={`item_details_block_variations_item_price ${isSelected(variation) ? 'item_details_block_variations_item_price_selected' : ''}`}>
                                {variation.price}
                            </div>
                        )}

                        {Array.isArray(variation.image) && variation.image.length > 0 && variation.image[0]?.path && (
                            <img className="item_details_block_variation_item_icon" src={variation.image[0].path} />
                        )}
                    </div>
                ))}
            </div>

        </div>
    );
};

export default ItemDetailsBlockVariations;
